(() => {
  'use strict';
  const page = document.getElementById('lisPage');
  if (!page) return;
  const $ = (s, r = page) => r.querySelector(s);
  const $$ = (s, r = page) => Array.from(r.querySelectorAll(s));
  const reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const tete = $('.lis-tete'), accueil = $('#lisAccueil');
  if (tete && accueil) {
    let att = 0;
    const majTete = () => { att = 0; tete.classList.toggle('lis-sombre', accueil.getBoundingClientRect().bottom > tete.offsetHeight + 1); };
    addEventListener('scroll', () => { if (!att) att = requestAnimationFrame(majTete); }, { passive: true });
    majTete();
  }

  const imgs = $$('.lis-g-img'), vigs = $$('.lis-vignettes button'), compte = $('.lis-g-compte b');
  let actif = 0, minuteur = 0;
  const montrer = (i) => {
    if (!imgs.length) return;
    i = (i + imgs.length) % imgs.length;
    if (i === actif) return;
    imgs[actif].classList.remove('actif'); vigs[actif].classList.remove('actif'); vigs[actif].removeAttribute('aria-selected');
    actif = i;
    imgs[actif].classList.add('actif'); vigs[actif].classList.add('actif'); vigs[actif].setAttribute('aria-selected', 'true');
    if (compte) compte.textContent = String(actif + 1);
    const v = vigs[actif], bande = v.parentElement;
    if (bande && bande.scrollWidth > bande.clientWidth) bande.scrollTo({ left: v.offsetLeft - bande.clientWidth / 2 + v.clientWidth / 2, behavior: reduit ? 'auto' : 'smooth' });
  };
  vigs.forEach((b, i) => b.addEventListener('click', () => { montrer(i); clearInterval(minuteur); }));
  const scene = $('.lis-g-scene');
  if (scene) {
    let x0 = null, y0 = 0;
    scene.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    scene.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { montrer(actif + (dx < 0 ? 1 : -1)); clearInterval(minuteur); }
    });
    if (!reduit && 'IntersectionObserver' in window) {
      let vu = false;
      new IntersectionObserver(([e]) => { vu = e.isIntersecting; }).observe(scene);
      minuteur = setInterval(() => { if (vu && !document.hidden) montrer(actif + 1); }, 5200);
    }
  }

  const offres = $$('.lis-offre'), prixBarre = $('#lisBarrePrix'), ctaPrix = $('#ctaPrix');
  const majOffre = () => {
    offres.forEach((o) => {
      const on = $('input', o).checked;
      o.classList.toggle('choisie', on);
      if (on && prixBarre) prixBarre.textContent = o.dataset.prix;
      if (on && ctaPrix) ctaPrix.textContent = o.dataset.prix;
    });
  };
  offres.forEach((o) => $('input', o).addEventListener('change', majOffre));
  majOffre();

  const pins = $$('.lis-pin'), zones = $$('.lis-zones li');
  const allumer = (z) => {
    pins.forEach((p) => p.classList.toggle('actif', p.dataset.zone === z));
    zones.forEach((l) => l.classList.toggle('actif', l.dataset.zone === z));
  };
  pins.forEach((p) => {
    p.addEventListener('click', () => allumer(p.dataset.zone));
    p.addEventListener('mouseenter', () => allumer(p.dataset.zone));
  });
  zones.forEach((l) => {
    l.addEventListener('mouseenter', () => allumer(l.dataset.zone));
    l.addEventListener('click', () => allumer(l.dataset.zone));
  });
  if (pins.length) allumer('1');

  $$('.lis-av-cadre').forEach((c, n) => {
    const inp = $('input', c);
    let glisse = false, x0 = 0, y0 = 0, souris = false, anim = 0;
    const poser = (v) => { v = Math.max(0, Math.min(100, v)); c.style.setProperty('--p', v + '%'); inp.value = Math.round(v); };
    const depuis = (e) => { const r = c.getBoundingClientRect(); poser((e.clientX - r.left) / r.width * 100); };
    const stop = () => { cancelAnimationFrame(anim); anim = -1; };
    c.addEventListener('pointerdown', (e) => {
      stop(); souris = e.pointerType === 'mouse'; x0 = e.clientX; y0 = e.clientY; glisse = souris;
      if (souris) { c.setPointerCapture(e.pointerId); depuis(e); }
    });
    c.addEventListener('pointermove', (e) => {
      if (!glisse && !souris && e.buttons !== 0 && Math.abs(e.clientX - x0) > 6 && Math.abs(e.clientX - x0) > Math.abs(e.clientY - y0)) { glisse = true; c.setPointerCapture(e.pointerId); }
      if (glisse) depuis(e);
    });
    const fin = () => { glisse = false; };
    c.addEventListener('pointerup', fin); c.addEventListener('pointercancel', fin);
    inp.addEventListener('input', () => { stop(); poser(+inp.value); });
    if (!reduit && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return; io.disconnect();
        setTimeout(() => {
          if (anim === -1) return;
          const t0 = performance.now(), d = 2400;
          const pas = (t) => {
            if (anim === -1) return;
            const k = Math.min(1, (t - t0) / d);
            poser(50 + Math.sin(k * Math.PI * 2) * 22 * (1 - k * 0.3));
            if (k < 1) anim = requestAnimationFrame(pas); else poser(50);
          };
          anim = requestAnimationFrame(pas);
        }, 500 + n * 250);
      }, { threshold: 0.6 });
      io.observe(c);
    }
  });

  if (!reduit && 'IntersectionObserver' in window) {
    page.classList.add('lis-anim');
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-rv]').forEach((el) => {
      const frere = el.parentElement ? Array.from(el.parentElement.children).filter((c) => c.hasAttribute('data-rv')).indexOf(el) : 0;
      el.style.transitionDelay = (Math.min(frere, 5) * 0.08) + 's';
      io.observe(el);
    });
  }

  const barre = $('#lisBarre'), btn = $('#lisBtn');
  if (barre && btn && 'IntersectionObserver' in window) {
    let fin = false, vuBtn = true;
    const maj = () => {
      const v = !vuBtn && !fin && window.scrollY > 300;
      barre.classList.toggle('visible', v);
      barre.setAttribute('aria-hidden', v ? 'false' : 'true');
      const bouton = barre.querySelector('button');
      if (bouton) bouton.tabIndex = v ? 0 : -1;
      document.documentElement.classList.toggle('lis-barre-on', v && matchMedia('(max-width: 900px)').matches);
    };
    new IntersectionObserver(([e]) => { vuBtn = e.isIntersecting; maj(); }).observe(btn);
    let attB = 0;
    addEventListener('scroll', () => { if (!attB) attB = requestAnimationFrame(() => { attB = 0; maj(); }); }, { passive: true });
    const pied = $('.lis-fin');
    if (pied) new IntersectionObserver(([e]) => { fin = e.isIntersecting; maj(); }).observe(pied);
  }
})();
